// extracted by mini-css-extract-plugin
module.exports = {"addCustomerModal":"AddCustomerModal_addCustomerModal__3k82c"};